var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('First'),_c('CasesNew',{staticClass:"section",attrs:{"cases":_vm.cases}}),_c('Achievements'),_c('Partners'),_c('Calculator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }